import React from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import BareMetalCheckout from './baremetalcheckout'; 
import { API_HOST,axiosRequest } from '../../constants/server.constant';
import Axios from 'axios'

export default class BareMetalPromo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stripePromise :null,
            company : ""
        };  
        this.loadStripeData = this.loadStripeData.bind(this)
       
    } 

     componentDidMount(){
        let path = window.location.pathname.split("/")
        this.setState({
            company : path[path.length-1]
        })
        //this.loadCss();
        this.loadStripeData();
    }
    loadCss = ()=>{
        const link = document.createElement("link")
        link.href = "https://www.idrivecompute.com/promo/include/css/promo_style.css"
        link.rel = "stylesheet"
        link.type = "text/css"
        document
            .head
            .appendChild(link)
       
    }
    loadStripeData = ()=>{
        Axios.get(API_HOST+`/resource/stripe_public/`+Math.floor(Math.random() * 100) + 1,axiosRequest)
        .then(resp => {
            this.setState({
                stripePromise : loadStripe(resp.data.toString())
            })
        }).catch(function (error) {
            return false;
        });
    }
  
    render() {
        return (
            <Elements stripe={this.state.stripePromise} getCompany = {this.state.company} >
                 <BareMetalCheckout  />
            </Elements>
        )}
    
}
